import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { getProfessionalCategory } from '../../utils/constants'
import Footer from '../Footer'

const PrivateVetRoute = ({ children, freelanceDisallowed, ...rest }) => {
  const isLogged = !!localStorage.getItem('userData')
  const isFreelance = getProfessionalCategory() === 'FREELANCE'

  return (
    <>
      <Route
        {...rest}
        render={({ location }) => {
          return isLogged
            ? freelanceDisallowed && isFreelance
              ? <Redirect to={{ pathname: '/' }} />
              : (
                <>
                  {children}
                  <Footer privateRoute isVet />
                </>
              )
            : (
              <Redirect to={{ pathname: '/login', state: { from: location } }} />
            )
        }}
      />
    </>
  )
}

export default PrivateVetRoute
